import { HtmlParser } from '@calendly/html-parser'
import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { Popup, Header, Title, Footer } from '@calendly/ui/components/popup'

import { SpacedBody } from './styles'

const SupportModal = ({ title, onClose, children }) => (
  <Popup onClose={onClose}>
    <Header>
      <Title tabIndex="0">
        {title || I18n.t('publisher.billing.success.let_us_help')}
      </Title>
    </Header>
    <SpacedBody>
      {children}
    </SpacedBody>
    <Footer>
      <Button onClick={onClose}>{I18n.t('publisher.action.ok')}</Button>
    </Footer>
  </Popup>
)

// i18n-tasks-use t('publisher.billing.upgrade_tier.contact_support_html')
export const ContactSupport = ({ contextMessageKey, tier, onClose }) => (
  <SupportModal onClose={onClose}>
    {HtmlParser(I18n.t(contextMessageKey, { scope: 'publisher.billing', email: 'billing@calendly.com', tier }))}
  </SupportModal>
)

export const UpgradeManualSupport = ({ onClose }) => (
  <SupportModal
    title={I18n.t('publisher.billing.success.needs_upgrade')}
    onClose={onClose}
  >
    {I18n.t('publisher.billing.success.feature_not_included')}
    {' '}
    {I18n.t('publisher.billing.success.support_notified')}
  </SupportModal>
)

export const IncreaseQuantitySupport = ({ onClose }) => (
  <SupportModal onClose={onClose}>
    {I18n.t('publisher.billing.success.subscription_full')}
    {' '}
    {I18n.t('publisher.billing.success.support_contacted')}
  </SupportModal>
)
